// The battery two-axis standard (ems-catalog ADR-002 §12, adopted platform-wide
// at the category charter): CHEMISTRY × TECHNOLOGY, classify-at-known-depth —
// chemistry alone is an honest coarse statement; technology refines it; every
// technology belongs to exactly one chemistry (derivable, below). Shared by
// the products catalog (asset_models), the solution register and the contract
// catalogue (both config tables carry CHEMISTRY only — technology grain is
// register-model truth; a technology-grain commitment lands additively with
// the first real charter that needs it).
//
// GROWTH PATH: new values enter by ADMISSION in ems-catalog (the standard's
// owner — a real product with evidence), then this mirrored code vocabulary
// updates in the companion PR. Never a migration; the DB has no CHECKs on
// these columns (ADR-067's code-vocabulary law: catalog-owned set, no DB CHECKs).
import { z } from 'zod';
export const BATTERY_CHEMISTRIES = ['lead_acid', 'lithium', 'nickel_cadmium'];
export const BatteryChemistrySchema = z.enum(BATTERY_CHEMISTRIES);
export const BATTERY_TECHNOLOGIES = ['vented', 'opzs', 'vrla', 'vrla_agm', 'vrla_gel', 'opzv', 'lfp', 'nmc'];
export const BatteryTechnologySchema = z.enum(BATTERY_TECHNOLOGIES);
/** Every technology's one chemistry — classify-at-known-depth's derivation. */
export const TECHNOLOGY_CHEMISTRY = {
    vented: 'lead_acid',
    opzs: 'lead_acid',
    vrla: 'lead_acid',
    vrla_agm: 'lead_acid',
    vrla_gel: 'lead_acid',
    opzv: 'lead_acid',
    lfp: 'lithium',
    nmc: 'lithium',
};
/** A chemistry+technology pair is coherent when the technology (if stated)
 *  belongs to the chemistry. */
export function batteryPairCoherent(chemistry, technology) {
    if (!technology)
        return true;
    if (!chemistry)
        return false;
    return TECHNOLOGY_CHEMISTRY[technology] === chemistry;
}
